<template>
  <main class="notice-page">
    <header class="notice-page__header"><h1>Message Board</h1></header>
    <van-pull-refresh v-model="isLoading" class="notice-page__refresh" @refresh="onRefresh">
      <section class="notice-page__list">
        <article v-for="(item, index) in notice" :key="item.id || index" class="notice-card">
          <time>{{ dateOf(item) }}</time>
          <p>{{ item.text || item.content || item.name }}</p>
        </article>
      </section>
    </van-pull-refresh>
  </main>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice:{},
      loading: false,
      finished: false,
    };
  },
  methods: {
    dateOf(item) {
      return item.create_time || item.name || "";
    },
    back(){
      return window.history.back();
    },
    getNoticeList(){
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        this.notice = Array.isArray(res.data) ? res.data : [];
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  }
};
</script>

<style scoped>
.notice-page {
  min-height: 100vh;
  padding-bottom: calc(5.3rem + env(safe-area-inset-bottom));
  background: #f4f4f7;
}

.notice-page__header {
  height: 3.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.04rem solid #e6e5ea;
  background: #f8f8fb;
}

.notice-page__header h1 {
  margin: 0;
  color: #282238;
  font-size: 1.1rem;
  font-weight: 700;
}

.notice-page__refresh { min-height: calc(100vh - 3.28rem); }

.notice-page__list { padding: 0.78rem 0.65rem 1rem; }

.notice-card {
  margin-bottom: 0.72rem;
  padding: 0.78rem 0.88rem 0.84rem;
  border-radius: 0.7rem;
  background: #fff;
  box-shadow: 0 0.24rem 0.6rem rgba(43, 38, 55, 0.09);
}

.notice-card time {
  display: block;
  color: #17131f;
  font-size: 0.88rem;
  font-weight: 700;
}

.notice-card p {
  margin: 0.58rem 0 0;
  color: #4c8294;
  font-size: 0.82rem;
  font-weight: 400;
  line-height: 1.72;
  white-space: pre-line;
}
</style>
